var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SonarSelector.scss';
import classNames from 'classnames';
import { EditBox } from './EditBox';
import { getClosestRow } from '@lib/popups';
import { haltClickEventPropagation } from '@lib/events';
import { stringContainsSubstringCaseInsensitive } from '@sonar-software/sonar-ts-lib';
import { Else, If, Then } from 'react-if';
import { useCurrentUser } from '@hooks';
import React, { useCallback, useRef } from 'react';
import { Row, Select } from 'antd';
const handleOnSearch = (input, option) => { var _a; return stringContainsSubstringCaseInsensitive(String((_a = option === null || option === void 0 ? void 0 : option.searchValue) !== null && _a !== void 0 ? _a : option === null || option === void 0 ? void 0 : option.label), input); };
export const SonarSelector = (_a) => {
    var { allowClear = true, allowReadonly, boxless, className, defaultValue, direction = 'vertical', disabled, getPopupContainer, isSalesforce, isSpreadsheet, mode, onChange, popupClassName, readOnlyDisplay, showArrow, showSearch = true, state, value } = _a, rest = __rest(_a, ["allowClear", "allowReadonly", "boxless", "className", "defaultValue", "direction", "disabled", "getPopupContainer", "isSalesforce", "isSpreadsheet", "mode", "onChange", "popupClassName", "readOnlyDisplay", "showArrow", "showSearch", "state", "value"]);
    const selectRef = useRef(null);
    const { isReadOnly: isReadOnlyUser } = useCurrentUser();
    const isReadOnly = isReadOnlyUser && !allowReadonly;
    const handleOnChange = useCallback((changeValue) => {
        var _a;
        if (onChange) {
            onChange(changeValue);
        }
        if (mode === 'tags') {
            (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [mode, onChange]);
    const selectorClassNames = classNames('sonar-selector', className, {
        boxless,
        horizontal: direction === 'horizontal',
        processing: state === null || state === void 0 ? void 0 : state.isProcessing,
        readonly: isReadOnly,
        vertical: direction === 'vertical'
    });
    return (React.createElement(EditBox, { className: selectorClassNames, isReadOnly: isReadOnly || disabled, isSalesforce: isSalesforce, isSpreadsheet: isSpreadsheet, readOnlyHover: true, selectionRef: selectRef, state: state },
        React.createElement(Row, { onClick: haltClickEventPropagation, wrap: false },
            React.createElement(If, { condition: !isReadOnly },
                React.createElement(Then, null,
                    React.createElement(Select, Object.assign({}, rest, { allowClear: allowClear, defaultValue: defaultValue, disabled: disabled, filterOption: handleOnSearch, getPopupContainer: getPopupContainer !== null && getPopupContainer !== void 0 ? getPopupContainer : getClosestRow, mode: mode, onChange: handleOnChange, optionLabelProp: 'optionLabel', popupClassName: classNames('sonar-selector-popup', popupClassName), ref: selectRef, removeIcon: null, showAction: ['focus'], showSearch: showSearch, suffixIcon: showArrow ? undefined : null, value: value !== null && value !== void 0 ? value : defaultValue }))),
                React.createElement(Else, null, readOnlyDisplay)))));
};
